import { Modal } from './Modal'
import { Button } from './Button'
import { Info } from 'lucide-react'

export interface AlertDialogProps {
  isOpen: boolean
  onClose: () => void
  title: string
  message: string
  closeLabel?: string
}

export function AlertDialog({
  isOpen,
  onClose,
  title,
  message,
  closeLabel = 'OK',
}: AlertDialogProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className="flex flex-col items-center text-center">
        <div className="mb-4 text-info">
          <Info className="w-12 h-12" />
        </div>
        <h3 className="font-bold text-lg mb-2">{title}</h3>
        <p className="text-base-content/70">{message}</p>
      </div>
      <div className="modal-action justify-center">
        <Button onClick={onClose}>{closeLabel}</Button>
      </div>
    </Modal>
  )
}
